export const PROD = true;

export let BASE_URL =
  PROD === true
    ? `https://coaching.notunkurifoundation.com`
    : `http://localhost:5004`;
